import { Link } from 'react-router';
import { t } from '../lib/i18n/t';

export default function NotFound() {
  return (
    <div className="page">
      <header className="page__head">
        <h1 className="page__title">{t('That page is not here')}</h1>
        <p className="page__lede">{t('The address you followed does not match anything in this prototype.')}</p>
      </header>
      <Link className="link-inline" to="/projects">
        {t('Go to your projects')}
      </Link>
    </div>
  );
}
